import Vue from 'vue'
import Vuex from 'vuex'
import { MENU_ACCOUNT_TYPE } from '@/const/const'
import ElementLocale from 'element-ui/lib/locale';
import zhTW from 'element-ui/lib/locale/lang/zh-TW';
import en from 'element-ui/lib/locale/lang/en';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menu: require('../../../main/resources/config/menu.json'), // 選單目錄(當前使用者可視)
    allMenu: require('../../../main/resources/config/menu.json'), // 所有選單目錄
    unitTable: undefined, // 單位對應表
    sidebar: {
      open: true
    },
    alarmCategoryList: [], // 所有異常群組
    alarmResultList: [], // 所有處理結果清單
    announcementList:[], // 公告
    locale: 'tw', // 語言環境
  },
  getters: {
    sidebar: state => state.sidebar,
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      state.sidebar.open = !state.sidebar.open
    },
    TOGGLE_LOCALE: (state, locale) => {
      state.locale = locale // 更新 state 中的語言
      console.log('state.locale', state.locale)
    }
  },
  actions: {
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    toggleLocale({ commit }, { locale, i18n }) {
      commit('TOGGLE_LOCALE', locale) // 設置語言
      i18n.locale = locale // 切換 i18n 語言環境
      // 切換 Element UI 語系
      const elementLocale = locale === 'en' ? en : zhTW;
      ElementLocale.use(elementLocale);
    },
    // 取得當前使用者可使用的選單目錄
    async getMenuByCurrentAccount({ state }, onRoute) {
      
      // 取得該帳號類型可使用的選單編號
      let allowed = MENU_ACCOUNT_TYPE.filter(m => {
        return m.accountType == localStorage.getItem('accountType')
      })
      let allowedMenuList = allowed[0].allowedMenu

      // 可用選單
      let allowedMenu = state.allMenu.filter(m => {
        return allowedMenuList.includes(m.title)
      })

      // // state.menu = allowedMenu
      //  console.log('allowedMenu', allowedMenu)
      // console.log('getMenuByCurrentAccount onRoute', onRoute)

      // 依每個頁面 重新調整 顯示的選單內容 
      if (onRoute) {
        if (onRoute.name == '監測圖台') {
          state.menu = allowedMenu.filter(menu => menu.title == '監測圖台')
          // 進入地圖的時候，清除剛剛選擇的群組
          localStorage.removeItem('currentCommunitGroup')
        } else if (onRoute.name == '用戶清單' || onRoute.name == '異常病例統計') {
          state.menu = allowedMenu.filter(menu => menu.title == '用戶清單' || menu.title == '異常病例統計')
        } else if (onRoute.name == '社區用水') {
          state.menu = allowedMenu.filter(menu => menu.title == '社區用水' || menu.title == '監測圖台')
        } else if (onRoute.name == '用水狀況' || onRoute.name == '用水指針查詢') {
          if(!localStorage.getItem('currentCommunitGroup')) {
            if(localStorage.getItem('accountType') == 'group') {
              state.menu = allowedMenu
            } else {
              state.menu = allowedMenu.filter(menu => menu.title != '社區用水' && menu.title != '用戶清單')
            }
          } else {
            state.menu = allowedMenu
          }
        } else {
          state.menu = allowedMenu
        }
      }
      
    },
     // 查詢單位對應表
    async getUnitTable({ state }) {
      return Vue.axios.get('/api/system/unit/table').then(response => {
        state.unitTable = response.data
        // console.log(state.unitTable)
        return true
      }).catch( error => {
        console.error(error)
        return false
      })
    },
    // 查詢所有異常群組
    async getAlarmCategory({ state }) {
      return Vue.axios.get("/api/report/profile/alarm/category").then(response => {
        state.alarmCategoryList = response.data
      })
    },
    // 查詢所有處理結果
    async getAlarmResult({ state }) {
      return Vue.axios.get("/api/report/profile/alarm/result").then(response => {
        state.alarmResultList = response.data
      })
    },
    // 查詢公告
    async getAnnouncement({ state }, params) {
      const { dateStart, dateEnd } = params;
      const system = "pms"
      
      return Vue.axios.get("/api/system/announcement?end="+ dateEnd + "&start="+ dateStart + "&system=" + system + "&sort=isImportant,Desc").then(response => {
        state.announcementList = response.data
      })
    },
  },
  modules: {
  }
})
